import React from "react";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { AuthenticatedResponse, qvals } from "../store/Interfaces";
import LoadingModal from "./LoadingModal";
import { Alert, Card, CardBody, CardFooter } from "reactstrap";
import { Link, RouteComponentProps } from "react-router-dom";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";

type OwnProps =
  {
    token: string;
  }
export default class ResetForm extends React.Component<OwnProps> {
  public state: {
    isLoading: boolean,
    isError: boolean,
    isSuccess: boolean,
    confirmPasswordError: string | undefined,
    passwordError: string | undefined,
    captchatoken: string | undefined,
    refreshReCaptcha: boolean,
    reloadcheck: boolean,
  }

  constructor(props: Readonly<OwnProps>) {
    super(props);
    this.state = {
      isLoading: false,
      isError: false,
      isSuccess: false,
      confirmPasswordError: undefined,
      passwordError: undefined,
      captchatoken: undefined,
      refreshReCaptcha: false,
      reloadcheck: true,
    };
  }

  handleValidSubmit = (event: any, values: {
    password: string;
    confirmpassword: string; w: string;
    captchatoken: string;
  }) => {

    if (this.state.reloadcheck) {

      this.setState({
        isLoading: true,
      });

      if (values.w && this.state.captchatoken) {
        values.captchatoken = this.state.captchatoken;

        this.setState({
          isLoading: true,
          refreshReCaptcha: !this.state.refreshReCaptcha,
          reloadcheck: false,
        });
        fetch(
          process.env.REACT_APP_API_HOST +
          `/Authenticate/Reset`,
          {
            method: "POST",
            // credentials: "include",
            body: JSON.stringify({
              token: values.w,
              password: values.password,
              captchatoken: values.captchatoken
            }),
            headers: {
              pragma: "no-cache",
              "cache-control": "no-cache",
              'Authorization': 'Bearer ' + values.w,
              "content-type": "application/json",
            },
          }
        )
          .then((response) => {
            if (!response.ok) {

              this.catchNok(response);

            } else {


              this.setState({
                isLoading: false,
                isError: false,
                isSuccess: true,
                refreshReCaptcha: !this.state.refreshReCaptcha,
              });


            }
          })

          .catch((error) => {
            this.catchError(error);

          });

      } else {
        setTimeout(() => {
          this.handleValidSubmit(event, values);
        }
          , 500)

      }
    }
  };

  public catchError(error: any) {
    this.setState({
      bans: [],
      isLoading: false,
      isError: true,
      refreshReCaptcha: !this.state.refreshReCaptcha,
    });
    // console.log(error);

  }
  public catchNok(response: Response) {
    this.setState({
      bans: [],
      isLoading: false,
      isError: true,
      refreshReCaptcha: !this.state.refreshReCaptcha,
    });

  }

  handleInvalidSubmit = (event: any, errors: any) => {

    // console.log(errors);
  };

  confirmPasswordvalidate = (value: string, ctx: any, input: any, cb: any) => {
    let password = (
      document.getElementById("password") as HTMLInputElement
    )
    if (password) {

      if (/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(value) && value === password.value) {
        value.length > 0 && this.setState({
          confirmPasswordError: undefined,
        });
        cb(true);
      } else {
        value.length > 0 && this.setState({
          confirmPasswordError: "Your password must have: 8 or more characters. Upper & lowercase letters. At least one number",
        });
        this.forceUpdate();
        cb(false);
      }
    }
  };

  passwordvalidate = (value: string, ctx: any, input: any, cb: any) => {
    if (/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(value)) {
      value.length > 0 && this.setState({
        passwordError: undefined,
      });
      cb(true);
    } else {

      value.length > 0 && this.setState({
        passwordError: "Your password must have: 8 or more characters. Upper & lowercase letters. At least one number",
      });
      this.forceUpdate();
      cb(false);
    }
  };

  public componentDidMount() {
    this.ensureDataFetched();
  }

  private ensureDataFetched() {

  }

  componentDidUpdate() {

  }
  render() {
    return (
      <>
        {!this.state.isSuccess && <><h3>
          Enter new password to continue.
        </h3>
          <hr /></>}
        <Card>
          <CardBody>

            {this.state.isSuccess === false && <div className="text-danger">Please enter new password of 8 or more characters with at least one uppercase letter, one lowercase letter and one number.</div>

            }
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              onInvalidSubmit={this.handleInvalidSubmit}
            >
              {this.state.isError === true && <Alert color="danger">There was an error with your submission. </Alert>}
              {this.state.isSuccess === true && <Alert color="success">Thank you!  Your password was set successfully.  Please go to the portal to sign in. <a href="/cabsbillportal/login">Frontier Customer Portal</a> </Alert>}

              {this.state.isSuccess === false &&
                <>
                  <AvField
                    id="password"
                    name="password"
                    label="New Password"
                    type="password"
                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please enter your password"
                      }, async: this.passwordvalidate,
                      minLength: {
                        value: 8,
                        errorMessage: "Your password must be 8 or more characters"
                      }
                      //this doesnt work here with the regex I want so needed to do async
                      // pattern: {
                      //   value: "/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/",
                      //   errorMessage:
                      //     "Your password must have: 8 or more characters. Upper & lowercase letters. At least one number"
                      // }
                      //,
                    }}
                  />



                  <AvField
                    name="confirmpassword"
                    label="Confirm Password"
                    type="password"

                    validate={{
                      required: {
                        value: true,
                        errorMessage: "Please enter your password"
                      }, async: this.confirmPasswordvalidate,
                      minLength: {
                        value: 8,
                        errorMessage: "Your password must be 8 or more characters"
                      }
                      //this doesnt work here with the regex I want so needed to do async
                      // pattern: {
                      //   value: "/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/",
                      //   errorMessage:
                      //     "Your password must have: 8 or more characters. Upper & lowercase letters. At least one number"
                      // }
                      //,
                    }}


                  />

                  <AvField
                    name="w"
                    type="text"
                    value={this.props.token}
                    style={{ visibility: "hidden" }}
                  />

                  <div className="d-flex flex-row flex-wrap justify-content-between">
                    <div className="d-flex flex-col">
                      <button className="btn btn-inverse btn-primary btn-sm" id="submit"><strong>SUBMIT</strong></button>


                    </div>
                    <div className="d-flex flex-col">
                      <GoogleReCaptcha
                        refreshReCaptcha={this.state.refreshReCaptcha}
                        onVerify={(token) => {
                          this.setState({ captchatoken: token })
                        }}
                      />

                    </div>
                  </div>
                </>

              }
              <LoadingModal isLoading={this.state.isLoading}></LoadingModal>
            </AvForm>
          </CardBody>
        </Card>
      </>
    );
  }
}
